<template>
    <div class="suivi-recla">
        
        <transition name="fade" mode="out-in">
        <router-view v-if="loaded"></router-view>
        <b-overlay v-else :show="true" rounded="sm" class="overlay">
            Chargement en cours...
        </b-overlay>
        </transition>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: "SuiviRecla",
        data() {
            return {
                loaded: false
            }
        },
        computed: {
            ...mapGetters('user', ['getCodeTiers']),
        },
        methods: {
            ...mapActions('title', ['setTitle']),
            ...mapActions('title', ['setTitle']),
            ...mapActions('categories', ['loadCategoriesFromAPI']),
            ...mapActions('types', ['loadTypesFromAPI']),
            ...mapActions('natures', ['loadNaturesFromAPI']),
            ...mapActions('motifs', ['loadMotifsFromAPI']),
            ...mapActions('evenements', ['loadEvenementsFromAPI']),
            ...mapActions('actions', ['loadActionsFromAPI']),
            ...mapActions('entrees', ['loadEntreesFromPartnr', 'loadAllEntreesFromAPI']),
            ...mapActions('partenaires', ['loadPartenairesFromAPI']),
            ...mapActions('programmes', ['loadProgrammesFromAPI'])
        },
        mounted() {
            this.setTitle('Suivi sollicitations')
            const promises = [
                this.loadCategoriesFromAPI(),
                this.loadTypesFromAPI(),
                this.loadNaturesFromAPI(),
                this.loadMotifsFromAPI(),
                this.loadEvenementsFromAPI(),
                this.loadActionsFromAPI(),
                this.loadPartenairesFromAPI(this.getCodeTiers),
                this.loadAllEntreesFromAPI(),
                this.loadProgrammesFromAPI()
            ];
            Promise.all(promises).then(() => {
                this.loaded = true;
            }).catch(error => {
                console.error('Error loading data:', error);
            });
        }
    }
</script>

<style scoped>

</style>